import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  selectUserRole,
  selectAuthLoading,
} from "../features/auth/authSlice";
import PageLoader from "./PageLoader";

export default function AdminRoute({ children }) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userRole = useSelector(selectUserRole);
  const loading = useSelector(selectAuthLoading);
  const location = useLocation();

  if (loading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Only allow admin and super_admin roles
  if (userRole !== "admin" && userRole !== "super_admin") {
    // Redirect non-admins to login (or could show an unauthorized page)
    return <Navigate to="/auth/login" replace />;
  }

  return children;
}
